import React, { Component } from 'react'
import { FormGroup, Label, Col, Input, Button } from 'reactstrap';
import Api from '../../../stores/auth-store'
import swal from 'sweetalert'

export default class Settings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loadsPerPage: this.props.settingObj.loadsToShow || 3,
            columnsPerGroup: this.props.settingObj.columnsPerGroup || 4,
            fontSize: this.props.settingObj.fontSize || 14,
            isChanged: false,
            loader: false
        }
    }

    handleSelect = (e, type) => {
        let value = e.target.value;
        if (type === "loads") {
            this.setState({ loadsPerPage: Number(value), isChanged: true })
        }
        if (type === "column") {
            this.setState({ columnsPerGroup: Number(value), isChanged: true })
        }
        if (type === "font") {
            this.setState({ fontSize: +value, isChanged: true })
        }
    }
    updateSettings = () => {
        this.setState({ loader: true})
        let { loadsPerPage, columnsPerGroup, fontSize } = this.state;
        const _id = JSON.parse(localStorage.getItem('jumperDetails'))._id || null
        let payload = { loadsPerPage, columnsPerGroup, fontSize};
        Api.ChangeUserSettings({...payload, _id})
            .then(res => {
                const settings = JSON.parse(localStorage.getItem('jumperDetails'))
                settings.columnsPerGroup = payload.columnsPerGroup
                settings.loadsPerPage = payload.loadsPerPage
                settings.fontSize = payload.fontSize
                localStorage.setItem("jumperDetails", JSON.stringify(settings))
                this.setState({ loader: false })
                this.props.childSettings(payload)
                this.props.toggleModal(false)
            })
            .catch(err => {
                this.setState({ loader: false })
                this.props.toggleModal(false)
                swal({
                    title: 'Something went wrong',
                    text: 'Please contact admin',
                     icon: 'error'
                })
            })
       
    }
    render() {
        let { isChanged } = this.state;
        return (
            <div className="settings container">
                {this.props?.settingObj?.loadsToShow && <Select label="Loads per page" value={this.state.loadsPerPage} max={6}
                    handleSelect={(e) => this.handleSelect(e, 'loads')}
                />}
                {this.props?.settingObj?.loadsToShow && <Select label="Column per load" value={this.state.columnsPerGroup} max={4}
                    handleSelect={(e) => this.handleSelect(e, 'column')}
                />}
                <Select label="Select Font" value={this.state.fontSize} max={24}
                    handleSelect={(e) => this.handleSelect(e, 'font')} isFont={true}
                />
                <Button color="success" disabled={!isChanged} onClick={this.updateSettings}>Save</Button>
            </div>
        )
    }
}
function Select({ value, handleSelect, label, max, isFont }) {
    const returnOptionList = () => {
        if (isFont) {
            let m = [];
            for (let i = 9; i <= max; i++) {
                m.push(<option>{i}</option>)
            }
            return m;
        } else {
            let m = [];
            for (let i = 1; i <= max; i++) {
                m.push(<option>{i}</option>)
            }
            return m;
        }
    }
    return (
        <FormGroup row>
            <Label for="exampleSelect" sm={8} className="px-0">{label}</Label>
            <Col sm={4} className="px-0">
                <Input type="select" name="select" value={value} onChange={handleSelect}>
                    {returnOptionList()}
                </Input>
            </Col>
        </FormGroup>
    )
}
